module.exports = __webpack_public_path__ + "img/1fb7efc.png";